import { render } from "./MailsDetail.vue?vue&type=template&id=514e7a0f&scoped=true"
import script from "./MailsDetail.vue?vue&type=script&lang=js"
export * from "./MailsDetail.vue?vue&type=script&lang=js"

import "./MailsDetail.vue?vue&type=style&index=0&id=514e7a0f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514e7a0f"]])

export default __exports__